export enum RepeatMode {
  NONE,
  ONE,
  BOTH,
  ALL,
}

export enum SockPartArea {
  None, //Unnecessary if this wasnt javascript, where 0 => undefined
  Leg,
  TopFoot,
  Heel,
  BottomFoot,
}
export enum SockPartAreaGroup {
  None, //Unnecessary if this wasnt javascript, where 0 => undefined
  Leg,
  Foot,
  Heel,
}
export enum SweaterPartArea {
  None, //Unnecessary if this wasnt javascript, where 0 => undefined
  LeftArm,
  RightArm,
  FrontTorso,
  BackTorso,
  Collar,
}
export enum SweaterPartAreaGroup {
  None, //Unnecessary if this wasnt javascript, where 0 => undefined
  Arms,
  Torso,
  Collar,
}
export type AreaGroup = SweaterPartAreaGroup | SockPartAreaGroup;
export enum DrawTypes {
  None,
  Brush,
  Bucket,
  Pattern,
  Eraser,
  Warning,
}

export enum KnitabilityProblem {
  None,
  Warning,
  Error,
}

export enum PlacementLineType {
  None,
  Top,
  Center,
  Bottom,
}
